import axios from 'axios';
import {API_ROOT} from '../../api-config';


export function getInventorySources(filters, response) {
    var fetch_data = true;
    var current_timestamp = Math.round((new Date()).getTime() / 1000);
    if (localStorage.getItem('inventory_sources') !== null) {
        var inventory_sources = JSON.parse(localStorage.getItem('inventory_sources'));
        if (inventory_sources.date_fetched > (current_timestamp - (60 * 10))) {
            fetch_data = false;
            filter(filters, inventory_sources.data);
        }
    }
    if (fetch_data) {
        axios.defaults.withCredentials = true;
        axios.get(`${API_ROOT}/inventory/sources`, {withCredentials: true})
            .then(function (ajax_response) {
                var inventory_sources = {};
                inventory_sources.data = {};
                inventory_sources.data = ajax_response.data;
                inventory_sources.date_fetched = current_timestamp;
                localStorage.setItem('inventory_sources', JSON.stringify(inventory_sources));
                filter(filters, inventory_sources.data);
            })
            .catch(function (error) {
                response({});
            });
    }

    function filter(filters, data) {
        var new_data = {}
        if (filters == "can_deliver") {
            for (var key in data) {
                if (data[key].can_deliver == 1) {
                    new_data[key] = data[key];
                }
            }
        } else {
            new_data = data;
        }
        response(new_data);
    }
}

/* ---------------------- new inventory subsystem ---------------------- */

export function getInvLists(response) {
    axios.defaults.withCredentials = true;
    axios.get(`${API_ROOT}/inventory/lists`, {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function () {
            response({items: [], locations: [], suppliers: [], accounts: [], boms: []});
        });
}

export function getStock(location_id, response) {
    axios.defaults.withCredentials = true;
    axios.get(`${API_ROOT}/inventory/stock?location_id=` + (location_id || 'all'), {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function (error) {
            response({rows: [], locations: [], error});
        });
}

export function getPendingDocs(response) {
    axios.defaults.withCredentials = true;
    axios.get(`${API_ROOT}/inventory/pending`, {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function () {
            response([]);
        });
}

export function getInvDocuments(type, response) {
    axios.defaults.withCredentials = true;
    axios.get(`${API_ROOT}/inventory/documents` + (type ? `?type=${type}` : ''), {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function () {
            response([]);
        });
}

export function saveInvDocument(doc_type, data, done, fail) {
    axios.defaults.withCredentials = true;
    axios.post(`${API_ROOT}/inventory/document/` + doc_type, data, {withCredentials: true})
        .then(function (ajax_response) {
            done(ajax_response.data);
        })
        .catch(function (error) {
            fail(error.response && error.response.data ? error.response.data.Message : 'Save failed');
        });
}

export function invDocAction(document_id, action, data, done, fail) {
    axios.defaults.withCredentials = true;
    axios.post(`${API_ROOT}/inventory/document/` + document_id + `/` + action, data || {}, {withCredentials: true})
        .then(function (ajax_response) {
            done(ajax_response.data);
        })
        .catch(function (error) {
            fail(error.response && error.response.data ? error.response.data.Message : 'Action failed');
        });
}

export function getLedger(params, response) {
    axios.defaults.withCredentials = true;
    axios.get(`${API_ROOT}/inventory/ledger`, {params: params, withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function () {
            response([]);
        });
}

export function getProducts(response) {
    var fetch_data = true;
    var current_timestamp = Math.round((new Date()).getTime() / 1000);
    if (localStorage.getItem('products') !== null) {
        var inventory_sources = JSON.parse(localStorage.getItem('products'));
        if (inventory_sources.date_fetched > (current_timestamp - (60 * 60 * 24))) {
            fetch_data = false;
            response(inventory_sources.data);
        }
    }
    if (fetch_data) {
        axios.defaults.withCredentials = true;
        axios.get(`${API_ROOT}/products/`, {withCredentials: true})
            .then(function (ajax_response) {
                var inventory_sources = {};
                inventory_sources.data = {};
                inventory_sources.data = ajax_response.data;
                inventory_sources.date_fetched = current_timestamp;
                localStorage.setItem('products', JSON.stringify(inventory_sources));
                response(inventory_sources.data);
            })
            .catch(function (error) {
                response({});
            });
    }
}
